import { render, staticRenderFns } from "./ShowBox.vue?vue&type=template&id=d987dfa6&scoped=true&lang=pug&"
import script from "./ShowBox.vue?vue&type=script&lang=js&"
export * from "./ShowBox.vue?vue&type=script&lang=js&"
import style0 from "./ShowBox.vue?vue&type=style&index=0&id=d987dfa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987dfa6",
  null
  
)

export default component.exports